import { render, staticRenderFns } from "./DocentesDesvinculadosPage.vue?vue&type=template&id=2483bef6"
import script from "./DocentesDesvinculadosPage.js?vue&type=script&lang=js&external"
export * from "./DocentesDesvinculadosPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports